import React from 'react';
import { connect } from 'react-redux';

import {
  workflowAddFinalizeApproval,
  workflowSetFinalizeTaskDescription,
} from '~/actions/workflow';
import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';
import { getFinalizeTaskById } from '~/reducers/workflow';
import Box from '~/ui/components/Box/Box';
import { toSnakeTrimmed } from '~/utils/strings';
import { coerceName } from '~/utils/workflow';

import DescriptionTextAreaForm from '../../shared/DescriptionTextAreaForm';
import PhaseItem from './PhaseItem/PhaseItem';

function Phase({
  phaseId,
  position,
  // connected
  disabled,
  phase,
  workflowSetFinalizeTaskDescription,
  workflowAddFinalizeApproval,
}) {
  const intl = useIntl();
  const coercedPhaseName = coerceName(
    phase.name,
    intl.formatMessage({
      id: 'Finalize.defaultTaskName',
      defaultMessage: 'Finalize Task',
      description: 'Default name for a new finalize task.',
    }),
    position,
  );
  const phaseName = toSnakeTrimmed(coercedPhaseName);

  return (
    <Box disabled={disabled}>
      <Box pb={2}>
        <DescriptionTextAreaForm
          description={phase.description}
          disabled={disabled}
          id={`workflow--finalize-phase-name=${phaseName}-add-description`}
          onUpdate={(value) =>
            workflowSetFinalizeTaskDescription({ value, phaseId })
          }
        />
      </Box>

      {phase.approvals.map((approval, index) => {
        return (
          <PhaseItem
            index={index}
            canReorder={phase.approvals.length > 1}
            phaseId={phase.id}
            approval={approval}
            key={approval.id}
          />
        );
      })}

      <Button
        id={`workflow--finalize-phase-name=${phaseName}-add-task`}
        text={intl.formatMessage({
          id: 'Phase.addTaskButton',
          defaultMessage: 'Add Task',
          description: 'Button text to add a new task to the phase',
        })}
        onClick={() => workflowAddFinalizeApproval(phaseId)}
      />
    </Box>
  );
}

function mapStateToProps({ builder, workflow }, { phaseId }) {
  return {
    disabled: !builder.shouldEnableAllComponents,
    phase: getFinalizeTaskById(workflow, phaseId),
  };
}

export default connect(mapStateToProps, {
  workflowSetFinalizeTaskDescription,
  workflowAddFinalizeApproval,
})(Phase);
